import './About.css';
export function About(props){
  console.log(props)
  return (
    <div className='about_container'>
      <span>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Fuga illo veritatis aliquid, nostrum tempora esse inventore sint exercitationem. Facilis eos omnis a officiis assumenda autem doloribus aperiam quisquam eius ipsa?
      </span>
      <span> - Lorem , 2205</span>
    </div>

  );
}